<template>
  <a-card>
    <template slot="title" style="padding: 0px !important">
      <div>
        <div class="ant-card-head-wrapper">
          <div class="ant-card-head-title" style="padding: 0px !important">
            <a-icon type="bar-chart" />
            &nbsp;&nbsp;Dashboard
          </div>
        </div>
      </div>
    </template>
    <div slot="extra" style="display: flex; align-items: center">
      <span style="padding-right: 5px">Periode : </span
      ><a-month-picker
        v-model="f_date"
        :allowClear="false"
        @change="f_dateChange"
        style="float: right; width: 100px"
      />
      <div style="display: flex; align-items: center">
        <span style="padding-left: 10px; padding-right: 5px"
          >&nbsp;Jumlah Data :
        </span>
        <a-select
          v-model="f_limit"
          show-search
          style="min-width: 100px"
          :filterOption="optionFilter"
          @change="f_limitChange"
        >
          <a-select-option key="3" value="3">Top 3</a-select-option>
          <a-select-option key="5" value="5">Top 5</a-select-option>
          <a-select-option key="10" value="10">Top 10</a-select-option>
        </a-select>
      </div>
      <a-button
        type="primary"
        :loading="loadingCetakAll"
        style="padding-left: 10px; margin-left: 10px"
        @click="handlePrintAll"
        >Print All</a-button
      >
    </div>
    <a-collapse v-model="activeKey" accordion>
      <a-collapse-panel key="0" header="Workforce">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '0'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <a-row type="flex" :gutter="24">
          <a-col :span="24" :md="8" class="mb-15">
            <PieChart
              chart-id="total-karyawan-pie-chart"
              title="Total Karyawan"
              :chart-data="totalKaryawanChartData"
              :customStyle="{
                position: 'relative',
                width: '260px',
                height: '260px'
              }"
              :loading="loadingWorkforce.length > 0"
            />
          </a-col>
          <a-col :span="24" :md="8" class="mb-15">
            <PieChart
              chart-id="usia-karyawan-pie-chart"
              title="Usia Karyawan"
              :chart-data="usiaKaryawanChartData"
              :customStyle="{
                position: 'relative',
                width: '260px',
                height: '260px'
              }"
              :loading="loadingWorkforce.length > 0"
            />
          </a-col>
          <a-col :span="24" :md="8" class="mb-15">
            <PieChart
              chart-id="site-karyawan-pie-chart"
              title="Site Karyawan"
              :chart-data="siteKaryawanChartData"
              :customStyle="{
                position: 'relative',
                width: '260px',
                height: '260px'
              }"
              :loading="loadingWorkforce.length > 0"
            />
          </a-col>
        </a-row>
        <a-row type="flex" :gutter="24">
          <a-col :span="24" :md="8" class="mb-15">
            <PieChart
              chart-id="pendidikan-karyawan-pie-chart"
              title="Pendidikan Karyawan"
              :chart-data="pendidikanKaryawanChartData"
              :customStyle="{
                position: 'relative',
                width: '260px',
                height: '260px'
              }"
              :loading="loadingWorkforce.length > 0"
            />
          </a-col>
          <a-col :span="24" :md="8" class="mb-15">
            <PieChart
              chart-id="gender-karyawan-pie-chart"
              title="Gender Karyawan"
              :chart-data="genderKaryawanChartData"
              :customStyle="{
                position: 'relative',
                width: '260px',
                height: '260px'
              }"
              :loading="loadingWorkforce.length > 0"
            />
          </a-col>
          <a-col :span="24" :md="8" class="mb-15">
            <PieChart
              chart-id="agama-karyawan-pie-chart"
              title="Agama Karyawan"
              :chart-data="agamaKaryawanChartData"
              :customStyle="{
                position: 'relative',
                width: '260px',
                height: '260px'
              }"
              :loading="loadingWorkforce.length > 0"
            />
          </a-col>
        </a-row>
        <a-card
          :bordered="true"
          class="header-solid h-full"
          :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
        >
          <template #title>
            <h4 class="m-text-header-thin m-remove">
              Karyawan cuti, ijin, dinas hari ini
            </h4>
          </template>
          <a-table
            :columns="columnsKaryawanCutiIjinDinasToday"
            bordered
            :pagination="paginationCutiIjinDinasKaryawanToday"
            :data-source="listCutiIjinDinasKaryawanToday"
            :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : {}"
            :loading="loadingWorkforce.length > 0"
            size="small"
            key="tblKry"
            :rowKey="
              (record, index) => {
                return index;
              }
            "
          >
            <template slot="no" slot-scope="value, item, index">{{
              (paginationCutiIjinDinasKaryawanToday.page - 1) *
                paginationCutiIjinDinasKaryawanToday.pageSize +
                (index + 1)
            }}</template>
          </a-table>
        </a-card>
      </a-collapse-panel>
      <a-collapse-panel key="1" header="Kehadiran & Perijinan">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '1'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <a-row type="flex" :gutter="24">
          <a-col :span="24" :md="8" class="mb-15">
            <ChartList
              title="Sering Terlambat"
              :data="listSeringTerlambat"
              :loading="loadingSeringTerlambat.length > 0"
            ></ChartList>
          </a-col>
          <a-col :span="24" :md="8" class="mb-15">
            <ChartList
              title="Sering Lupa Check Out"
              :data="listSeringLupaCheckOut"
              :loading="loadingSeringLupaCheckOut.length > 0"
            ></ChartList>
          </a-col>
          <a-col :span="24" :md="8" class="mb-15">
            <ChartList
              title="Sering Pulang Awal"
              :data="listSeringPulangAwal"
              :loading="loadingSeringPulangAwal.length > 0"
            ></ChartList>
          </a-col>
        </a-row>
        <a-row type="flex" :gutter="16">
          <a-col :span="24" :md="6" class="mb-15">
            <ChartList
              title="Ijin Terlambat Terbanyak"
              :data="listIjinTerlambat"
              :loading="loadingIjinTerlambat.length > 0"
            ></ChartList>
          </a-col>
          <a-col :span="24" :md="6" class="mb-15">
            <ChartList
              title="Ijin Sakit Terbanyak"
              :data="listIjinSakit"
              :loading="loadingIjinSakit.length > 0"
            ></ChartList>
          </a-col>
          <a-col :span="24" :md="6" class="mb-15">
            <ChartList
              title="Ijin Lain-lain Terbanyak"
              :data="listIjinLain"
              :loading="loadingIjinLain.length > 0"
            ></ChartList>
          </a-col>
          <a-col :span="24" :md="6" class="mb-15">
            <ChartList
              title="Ijin Pulang Awal Terbanyak"
              :data="listIjinPulangAwal"
              :loading="loadingIjinPulangAwal.length > 0"
            ></ChartList>
          </a-col>
        </a-row>
        <a-row type="flex" :gutter="16">
          <a-col :span="24" :md="7">
            <ChartList
              title="Sering Cuti"
              :data="listSeringCuti"
              :loading="loadingSeringCuti.length > 0"
            ></ChartList>
          </a-col>
          <a-col :span="24" :md="7">
            <ChartList
              title="Sering Tanpa Keterangan"
              :data="listSeringTanpaKeterangan"
              :loading="loadingSeringTanpaKeterangan.length > 0"
            ></ChartList>
          </a-col>
          <a-col :span="24" :md="10">
            <ChartList
              title="Jam Kerja Kurang Terbanyak"
              :data="listJamKerjaKurang"
              :loading="loadingJamKerjaKurang.length > 0"
            ></ChartList>
          </a-col>
        </a-row>
      </a-collapse-panel>
      <a-collapse-panel key="2" header="Alokasi Pekerjaan">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '2'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <a-row :gutter="24">
          <a-col :span="24" :md="8" class="mb-15">
            <WidgetCounter
              title="Jumlah karyawan yang terlibat"
              :value="amountKaryawanPerPeriode"
              icon="user"
              :loading="loadingKaryawanPerPeriode.length > 0"
            ></WidgetCounter>
          </a-col>
          <a-col :span="24" :md="8" class="mb-15">
            <WidgetCounter
              title="Jumlah proyek yang dikerjakan"
              :value="amountProyekPerPeriode"
              icon="audit"
              :loading="loadingProyekPerPeriode.length > 0"
            ></WidgetCounter>
          </a-col>
          <a-col :span="24" :md="8" class="mb-15">
            <WidgetCounter
              title="Jumlah pekerjaan yang tercatat"
              :value="amountPekerjaanPerPeriode"
              icon="file"
              :loading="loadingPekerjaanPerPeriode.length > 0"
            ></WidgetCounter>
          </a-col>
        </a-row>
        <BarChart
          ref="alokasiChart"
          chart-id="alokasi-bar-chart"
          :chart-data="alokasiChartData"
          title="Jumlah Pekerjaan Per Proyek"
          :customStyle="{ position: 'relative', height: '300px' }"
          :loading="loadingPekerjaanPerPeriode.length > 0"
        />
      </a-collapse-panel>
      <a-collapse-panel key="3" header="Status Karyawan">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '3'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <div class="act-grid">
          <a-row :gutter="{ xs: 0, lg: 8 }">
            <a-col :xs="24" :lg="24">
              <a-row :gutter="16">
                <a-col :xs="24" :lg="8">
                  <a-select
                    v-model="f_posisi"
                    :class="
                      isMobile ? 'm-right margin-top w-full' : 'w-full m-right'
                    "
                    @change="f_posisiChange"
                  >
                    <a-select-option value="" disabled
                      >Pilih Posisi</a-select-option
                    >
                    <a-select-option
                      v-for="item in listPosisi"
                      :key="item.posisi"
                      >{{ item.posisi }}</a-select-option
                    >
                  </a-select>
                </a-col>
                <a-col :xs="24" :lg="8">
                  <a-select
                    v-model="f_divisi"
                    :class="
                      isMobile ? 'm-right margin-top w-full' : 'w-full m-right'
                    "
                    @change="f_divisiChange"
                  >
                    <a-select-option value="" disabled
                      >Pilih Divisi</a-select-option
                    >
                    <a-select-option
                      v-for="item in listDivisi"
                      :key="item.divisi"
                      >{{ item.divisi }}</a-select-option
                    >
                  </a-select>
                </a-col>
                <a-col :xs="24" :lg="6">
                  <a-select
                    v-model="f_status"
                    :class="
                      isMobile ? 'm-right margin-top w-full' : 'w-full m-right'
                    "
                    placeholder="Pilih Status"
                    :filterOption="optionFilter"
                    @change="f_statusChange"
                  >
                    <a-select-option value="" disabled
                      >Pilih Status</a-select-option
                    >
                    <a-select-option key="1" value="Habis Kontrak"
                      >Habis Kontrak</a-select-option
                    >
                    <a-select-option key="2" value="Kontrak"
                      >Kontrak</a-select-option
                    >
                    <a-select-option key="3" value="Pensiun"
                      >Pensiun</a-select-option
                    >
                    <a-select-option key="4" value="Resign"
                      >Resign</a-select-option
                    >
                    <a-select-option key="5" value="Tetap"
                      >Tetap</a-select-option
                    >
                  </a-select>
                </a-col>
                <a-col :xs="24" :lg="2">
                  <a-button type="primary" @click="handleReset">Reset</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </div>
        <a-table
          :columns="columnsStatusKaryawan"
          :data-source="listStatusKaryawan"
          bordered
          style="margin-top: 10px"
          :pagination="paginationStatusKaryawan"
          :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : {}"
          :loading="loadingStatusKaryawan.length > 0"
          size="small"
          key="tblStatusKaryawan"
          :rowKey="
            (record, index) => {
              return index;
            }
          "
        >
          <template slot="no" slot-scope="value, item, index">{{
            (paginationStatusKaryawan.page - 1) *
              paginationStatusKaryawan.pageSize +
              (index + 1)
          }}</template>
          <template slot="nama" slot-scope="value">
            <span>{{ value.nama }}</span>
          </template>
          <template slot="tlc" slot-scope="value">
            <span>{{ value.tlc }}</span>
          </template>
          <template slot="posisi" slot-scope="value"
            ><span>{{ value.posisi }}</span></template
          >
          <template slot="divisi" slot-scope="value">
            <span>{{ value.divisi }}</span>
          </template>
          <template slot="tgl_masuk" slot-scope="value">
            <span>{{ value.tgl_masuk }}</span>
          </template>
          <template slot="status" slot-scope="value">
            <TagStatus
              :color="getColorStatus(value.status)"
              :status="value.status"
            ></TagStatus>
          </template>
          <!-- <template slot="action" slot-scope="value, item, index">
            <div>
              <a-button
                type="primary"
                shape="circle"
                icon="form"
                @click="showModal(item)"
              />
            </div>
          </template> -->
        </a-table>
      </a-collapse-panel>
      <a-collapse-panel key="4" header="Hot Issue">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '4'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <span>Total Issue : {{ totalHotIssue }}</span>
        <a-table
          :columns="columnsHotIssue"
          :data-source="listHotIssue"
          bordered
          style="margin-top: 10px"
          :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : {}"
          :loading="loadingHotIssue.length > 0"
          size="small"
          key="tblHotIssue"
          :pagination="false"
          :rowKey="
            (record, index) => {
              return index;
            }
          "
        >
          <template slot="status" slot-scope="value, item">
            <TagStatus
              :color="getIssueColorStatus(item.status)"
              :status="getIssueDescStatus(item.status)"
            ></TagStatus>
          </template>
          <template slot="response" slot-scope="value, item">
            <a-row>
              <a-col :span="22">{{ item.response }}</a-col>
              <a-col :span="2">
                <a-button
                  v-if="item.file_doc_nm"
                  size="small"
                  type="link"
                  icon="paper-clip"
                  @click="openFile(item.file_doc_nm)"
                />
              </a-col>
            </a-row>
          </template>
        </a-table>
      </a-collapse-panel>
      <a-collapse-panel key="5" header="Lembur">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '5'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <a-row type="flex" :gutter="24">
          <a-col :span="24" :md="12" class="mb-15">
            <a-card
              :bordered="true"
              class="header-solid h-full"
              :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
            >
              <template #title>
                <h4 class="m-text-header-thin m-remove">
                  Realisasi Terbanyak
                </h4>
              </template>
              <a-table
                :columns="columnsLembur"
                :pagination="false"
                :data-source="listSeringLembur"
                :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : {}"
                :loading="loadingSeringLembur.length > 0"
                size="small"
                key="tblLembur"
                :rowKey="
                  (record, index) => {
                    return index;
                  }
                "
              >
                <template slot="nama" slot-scope="value"
                  ><p>
                    <strong>{{ value.tlc }}</strong>
                  </p>
                  <p>{{ value.nama }}</p></template
                >
                <template slot="hari" slot-scope="value">
                  <span>{{ value.hari }}</span>
                </template>
                <template slot="jam" slot-scope="value">
                  <span>{{ value.jam }}</span>
                </template>
              </a-table>
            </a-card>
          </a-col>
          <a-col :span="24" :md="12" class="mb-15">
            <BarChart
              chart-id="lembur-bar-chart"
              :chart-data="lemburChartData"
              title="Jumlah SPL Per Proyek"
              :is-horizontal="true"
              :customStyle="{
                position: 'relative',
                height: lemburChartHeight + 'px'
              }"
              :loading="loadingSeringLembur.length > 0"
            />
          </a-col>
          <a-col :span="24">
            <span style="font-size: 14px;font-weight: bold;">
              *) Keterangan: Data yang ditampilkan adalah data setelah proses
              rekap oleh HRD
            </span>
          </a-col>
        </a-row>
      </a-collapse-panel>
      <a-collapse-panel key="6" header="SPD">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '6'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <a-row type="flex" :gutter="24">
          <a-col :span="24" :md="12" class="mb-15">
            <a-row type="flex">
              <a-col :span="24">
                <WidgetCounter
                  title="SPD Terekap"
                  :value="amountSppdTerekap"
                  icon="wallet"
                  :loading="loadingSeringSppd.length > 0"
                ></WidgetCounter>
                <br />
              </a-col>
            </a-row>
            <a-row type="flex">
              <a-col :span="24">
                <a-card
                  :bordered="true"
                  class="header-solid h-full"
                  :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
                >
                  <template #title>
                    <h4 class="m-text-header-thin m-remove">Sering SPD</h4>
                  </template>
                  <a-table
                    :columns="columnsSppd"
                    :pagination="false"
                    :data-source="listSeringSppd"
                    :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : {}"
                    :loading="loadingSeringSppd.length > 0"
                    size="small"
                    key="tblSpd"
                    :rowKey="
                      (record, index) => {
                        return index;
                      }
                    "
                  >
                    <template slot="nama" slot-scope="value"
                      ><p>
                        <strong>{{ value.tlc }}</strong>
                      </p>
                      <p>{{ value.nama }}</p></template
                    >
                    <template slot="nilai" slot-scope="value">
                      <span>{{ formatRupiah(value.nilai) }}</span>
                    </template>
                  </a-table>
                </a-card>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24" :md="12" class="mb-15">
            <BarChart
              chart-id="spd-bar-chart"
              :chart-data="spdChartData"
              title="Jumlah SPD Per Proyek"
              :is-horizontal="true"
              :customStyle="{
                position: 'relative',
                height: spdChartHeight + 'px'
              }"
            />
          </a-col>
          <a-col :span="24">
            <span style="font-size: 14px;font-weight: bold;">
              *) Keterangan: Data yang ditampilkan adalah data setelah proses
              rekap oleh HRD
            </span>
          </a-col>
        </a-row>
      </a-collapse-panel>
      <a-collapse-panel key="7" header="Klaim Kesehatan">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '7'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <a-row type="flex" :gutter="24">
          <a-col :span="24" :md="12" class="mb-15">
            <a-row type="flex">
              <a-col :span="24">
                <WidgetCounter
                  title="Total Approved"
                  :value="amountKlaimApproved"
                  icon="wallet"
                  :loading="loadingSeringKlaimKesehatan.length > 0"
                ></WidgetCounter>
                <br />
              </a-col>
            </a-row>
            <a-row type="flex">
              <a-col :span="24">
                <ChartList
                  title="Sering Klaim"
                  :data="listSeringKlaimKesehatan"
                  :loading="loadingSeringKlaimKesehatan.length > 0"
                ></ChartList>
                <br />
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24" :md="12" class="mb-15">
            <a-card
              :bordered="true"
              class="header-solid h-full"
              :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
            >
              <template #title>
                <h4 class="m-text-header-thin m-remove">Realisasi Terbanyak</h4>
              </template>
              <a-table
                :columns="columnsKlaimKesehatan"
                :pagination="false"
                :data-source="listRealisasiKlaimKesehatanTerbanyak"
                :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : {}"
                :loading="loadingSeringKlaimKesehatan.length > 0"
                size="small"
                key="tblSpd"
                :rowKey="
                  (record, index) => {
                    return index;
                  }
                "
              >
                <template slot="nama" slot-scope="value"
                  ><p>
                    <strong>{{ value.tlc }}</strong>
                  </p>
                  <p>{{ value.nama }}</p></template
                >
                <template slot="klaim" slot-scope="value">
                  <span>{{ formatRupiah(value.klaim) }}</span>
                </template>
                <template slot="approved" slot-scope="value">
                  <span>{{ formatRupiah(value.approved) }}</span>
                </template>
              </a-table>
            </a-card>
          </a-col>
          <a-col :span="24">
            <span style="font-size: 14px;font-weight: bold;">
              *) Keterangan: Data yang ditampilkan adalah data setelah proses
              rekap oleh HRD
            </span>
          </a-col>
        </a-row>
      </a-collapse-panel>
      <a-collapse-panel key="8" header="Senioritas">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '8'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <a-row type="flex" :gutter="24">
          <a-col :span="24" :md="12">
            <PieChart
              chart-id="senioritas-pie-chart"
              title="Senioritas Karyawan"
              :chart-data="senioritasChartData"
              :customStyle="{
                position: 'relative',
                width: '300px',
                height: '300px'
              }"
              :loading="loadingSenioritas.length > 0"
            />
          </a-col>
          <a-col :span="24" :md="12">
            <ChartList
              title="Masa Kerja Terlama"
              :data="listMasaKerja"
              :loading="loadingMasaKerja.length > 0"
            ></ChartList>
          </a-col>
        </a-row>
      </a-collapse-panel>
      <a-collapse-panel key="9" header="Prediction System">
        <a-spin
          v-if="activeKey !== undefined && activeKey == '9'"
          slot="extra"
          :spinning="loadingCetak"
        >
          <a-icon type="printer" @click="handlePrint" />
        </a-spin>
        <a-card
          :bordered="true"
          class="header-solid h-full mb-2"
          :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
          :style="{ marginBottom: '16px' }"
        >
          <template #title>
            <h4 class="m-text-header-thin m-remove">
              Karyawan Akan Habis Kontrak
            </h4>
          </template>
          <a-table
            :columns="columnsHabisKontrak"
            :data-source="listHabisKontrak"
            bordered
            style="margin-top: 10px"
            :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : {}"
            :loading="loadingHabisKontrak.length > 0"
            size="small"
            key="tblHabisKontrak"
            :pagination="false"
            :row-class-name="
              (_record, index) =>
                _record.status ? 'row-' + _record.status : null
            "
            :rowKey="
              (record, index) => {
                return index;
              }
            "
          >
          </a-table>
        </a-card>
        <a-card
          :bordered="true"
          class="header-solid h-full"
          :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
        >
          <template #title>
            <h4 class="m-text-header-thin m-remove">
              Karyawan Akan Pensiun
            </h4>
          </template>
          <a-table
            :columns="columnsPensiun"
            :data-source="listPensiun"
            bordered
            style="margin-top: 10px"
            :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : {}"
            :loading="loadingPensiun.length > 0"
            size="small"
            key="tblPensiun"
            :pagination="false"
            :row-class-name="
              (_record, index) =>
                _record.status ? 'row-' + _record.status : null
            "
            :rowKey="
              (record, index) => {
                return index;
              }
            "
          >
          </a-table>
        </a-card>
      </a-collapse-panel>
    </a-collapse>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import ChartList from "../../../../components/chart/ChartList.vue";
import WidgetCounter from "../../../../components/chart/WidgetCounter.vue";
import TagStatus from "../../../../components/chart/TagStatus.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import BarChart from "../../../../components/chart/BarChart.vue";
import PieChart from "../../../../components/chart/PieChart.vue";

export default {
  mixins: [CurrencyFormat],
  components: {
    ChartList,
    WidgetCounter,
    TagStatus,
    BarChart,
    PieChart
  },
  data() {
    return {
      widthScreen: 0,
      heighScreen: 0,
      f_date: moment(),
      f_limit: "3",
      activeKey: "0",
      listSeringTerlambat: [],
      loadingSeringTerlambat: [],
      listSeringLupaCheckOut: [],
      loadingSeringLupaCheckOut: [],
      listSeringPulangAwal: [],
      loadingSeringPulangAwal: [],
      listIjinTerlambat: [],
      loadingIjinTerlambat: [],
      listIjinSakit: [],
      loadingIjinSakit: [],
      listIjinLain: [],
      loadingIjinLain: [],
      listIjinPulangAwal: [],
      loadingIjinPulangAwal: [],
      listSeringCuti: [],
      loadingSeringCuti: [],
      listSeringTanpaKeterangan: [],
      loadingSeringTanpaKeterangan: [],
      listJamKerjaKurang: [],
      loadingJamKerjaKurang: [],
      amountKaryawanPerPeriode: "0",
      loadingKaryawanPerPeriode: [],
      amountProyekPerPeriode: "0",
      loadingProyekPerPeriode: [],
      amountPekerjaanPerPeriode: "0",
      loadingPekerjaanPerPeriode: [],
      listKaryawanPerProyekPerPeriode: [],
      alokasiChartData: {
        labels: [],
        datasets: []
      },
      lemburChartData: {
        labels: [],
        datasets: []
      },
      spdChartData: {
        labels: [],
        datasets: []
      },
      lemburChartHeight: 400,
      spdChartHeight: 400,
      loadingKaryawanPerProyekPerPeriode: [],
      paginationAlokasi: {
        page: 1,
        onChange: page => {
          this.paginationAlokasi.page = page;
        },
        pageSize: 10,
        size: "default"
      },
      listStatusKaryawan: [],
      loadingStatusKaryawan: [],
      paginationStatusKaryawan: {
        page: 1,
        onChange: page => {
          this.paginationStatusKaryawan.page = page;
        },
        pageSize: 10,
        size: "default"
      },
      listSeringLembur: [],
      loadingSeringLembur: [],
      amountLemburTerbayar: "0",
      listSeringSppd: [],
      loadingSeringSppd: [],
      amountSppdTerekap: "0",
      listSeringKlaimKesehatan: [],
      loadingSeringKlaimKesehatan: [],
      listRealisasiKlaimKesehatanTerbanyak: [],
      amountKlaimApproved: "0",
      listHotIssue: [],
      loadingHotIssue: [],
      totalHotIssue: 0,
      f_status: "",
      listDivisi: [],
      f_divisi: "",
      listPosisi: [],
      f_posisi: "",
      loadingCetak: false,
      loadingCetakAll: false,
      senioritasChartData: {
        labels: [],
        datasets: []
      },
      loadingSenioritas: [],
      listMasaKerja: [],
      loadingMasaKerja: [],
      listHabisKontrak: [],
      loadingHabisKontrak: [],
      listPensiun: [],
      loadingPensiun: [],
      loadingWorkforce: [],
      totalKaryawanChartData: {
        labels: [],
        datasets: []
      },
      usiaKaryawanChartData: {
        labels: [],
        datasets: []
      },
      siteKaryawanChartData: {
        labels: [],
        datasets: []
      },
      genderKaryawanChartData: {
        labels: [],
        datasets: []
      },
      pendidikanKaryawanChartData: {
        labels: [],
        datasets: []
      },
      agamaKaryawanChartData: {
        labels: [],
        datasets: []
      },
      listCutiIjinDinasKaryawanToday: [],
      paginationCutiIjinDinasKaryawanToday: {
        page: 1,
        onChange: page => {
          this.paginationCutiIjinDinasKaryawanToday.page = page;
        },
        pageSize: 10,
        size: "default"
      }
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    columnsAlokasi() {
      const columns = [
        {
          title: "No",
          key: "no",
          align: "right",
          scopedSlots: { customRender: "no" }
        },
        {
          title: "Proyek",
          key: "c_proyek",
          scopedSlots: { customRender: "c_proyek" },
          sorter: (a, b) => b.c_proyek.localeCompare(a.c_proyek)
        },
        {
          title: "Jumlah Karyawan",
          key: "amount",
          align: "center",
          scopedSlots: { customRender: "amount" },
          sorter: (a, b) => b.amount.localeCompare(a.amount)
        },
        {
          title: "TLC",
          key: "tlc",
          scopedSlots: { customRender: "tlc" }
        }
      ];
      return columns;
    },
    columnsStatusKaryawan() {
      const columns = [
        {
          title: "No",
          className: "center",
          align: "right",
          key: "no",
          scopedSlots: { customRender: "no" }
        },
        {
          title: "Nama",
          dataIndex: "nama",
          key: "nama",
          sorter: (a, b) => b.nama.localeCompare(a.nama)
        },
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          sorter: (a, b) => b.tlc.localeCompare(a.tlc)
        },
        {
          title: "Posisi",
          dataIndex: "posisi",
          key: "posisi",
          sorter: (a, b) => b.posisi.localeCompare(a.posisi)
        },
        {
          title: "Divisi",
          dataIndex: "divisi",
          key: "divisi",
          sorter: (a, b) => b.divisi.localeCompare(a.divisi)
        },
        {
          title: "Tgl Masuk",
          dataIndex: "tgl_masuk",
          key: "tgl_masuk",
          align: "center",
          sorter: (a, b) => b.tgl_masuk.localeCompare(a.tgl_masuk)
        },
        {
          title: "Status",
          key: "status",
          align: "center",
          scopedSlots: { customRender: "status" },
          sorter: (a, b) => b.status.localeCompare(a.status)
        }
      ];
      return columns;
    },
    columnsHotIssue() {
      const columns = [
        {
          title: "No",
          className: "center",
          align: "center",
          dataIndex: "priority",
          key: "priority",
          width: "5%"
        },
        {
          title: "Issue",
          dataIndex: "issue",
          key: "issue",
          width: "40%"
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
          align: "center",
          width: "15%"
        },
        {
          title: "Response",
          dataIndex: "response",
          key: "response",
          scopedSlots: { customRender: "response" },
          width: "40%"
        }
      ];
      return columns;
    },
    columnsKlaimKesehatan() {
      const columns = [
        {
          title: "Nama",
          key: "nama",
          scopedSlots: { customRender: "nama" }
        },
        {
          title: "Klaim",
          key: "klaim",
          scopedSlots: { customRender: "klaim" }
        },
        {
          title: "Approved",
          key: "approved",
          scopedSlots: { customRender: "approved" }
        }
      ];
      return columns;
    },
    columnsLembur() {
      const columns = [
        {
          title: "Nama",
          key: "nama",
          scopedSlots: { customRender: "nama" }
        },
        {
          title: "Jumlah Hari",
          key: "hari",
          dataIndex: "hari",
          align: "center"
        },
        {
          title: "Jumlah Jam",
          key: "jam",
          dataIndex: "jam",
          align: "center"
        }
      ];
      return columns;
    },
    columnsSppd() {
      const columns = [
        {
          title: "Nama",
          key: "nama",
          scopedSlots: { customRender: "nama" }
        },
        {
          title: "Jumlah Hari",
          key: "hari",
          dataIndex: "hari",
          align: "center"
        },
        {
          title: "Nilai Rekap",
          key: "nilai",
          scopedSlots: { customRender: "nilai" }
        }
      ];
      return columns;
    },
    columnsHabisKontrak() {
      const columns = [
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          width: "10%",
          align: "center"
        },
        {
          title: "Nama",
          dataIndex: "nama",
          key: "nama",
          width: "50%"
        },
        {
          title: "Tanggal Mulai Kontrak",
          dataIndex: "tgl_mutasi",
          key: "tgl_mutasi",
          width: "20%",
          align: "center"
        },
        {
          title: "Tanggal Habis Kontrak",
          dataIndex: "end_kontrak",
          key: "end_kontrak",
          width: "20%",
          align: "center"
        }
      ];
      return columns;
    },
    columnsPensiun() {
      const columns = [
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          width: "10%",
          align: "center"
        },
        {
          title: "Nama",
          dataIndex: "nama",
          key: "nama",
          width: "40%"
        },
        {
          title: "Tanggal Pensiun",
          dataIndex: "tgl_pensiun",
          key: "tgl_pensiun",
          width: "15%",
          align: "center"
        },
        {
          title: "Sisa",
          dataIndex: "sisa",
          key: "sisa",
          width: "15%",
          align: "center"
        },
        {
          title: "Usia Saat Ini",
          dataIndex: "umur",
          key: "umur",
          width: "10%",
          align: "center"
        },
        {
          title: "Usia Saat Pensiun",
          dataIndex: "umur_pensiun",
          key: "umur_pensiun",
          width: "10%",
          align: "center"
        }
      ];
      return columns;
    },
    columnsKaryawanCutiIjinDinasToday() {
      const columns = [
        {
          title: "No",
          className: "center",
          align: "right",
          key: "no",
          scopedSlots: { customRender: "no" }
        },
        {
          title: "Nama",
          key: "nama",
          dataIndex: "nama",
          sorter: (a, b) => b.nama.localeCompare(a.nama)
        },
        {
          title: "TLC",
          key: "tlc",
          dataIndex: "tlc",
          sorter: (a, b) => b.nama.localeCompare(a.tlc)
        },
        {
          title: "Jenis",
          key: "tipe_tdk_masuk",
          dataIndex: "tipe_tdk_masuk",
          sorter: (a, b) => b.nama.localeCompare(a.tipe_tdk_masuk)
        },
        {
          title: "Keterangan",
          key: "keterangan",
          dataIndex: "keterangan",
          sorter: (a, b) => b.nama.localeCompare(a.keterangan)
        }
      ];
      return columns;
    }
  },
  mounted() {
    this.widthScreen = window.innerWidth;
    this.heighScreen = window.innerHeight;
    this.fetchSeringTerlambat();
    this.fetchSeringLupaCheckOut();
    this.fetchSeringPulangAwal();
    this.fetchIjinTerlambat();
    this.fetchIjinSakit();
    this.fetchIjinLain();
    this.fetchIjinPulangAwal();
    this.fetchSeringCuti();
    this.fetchSeringTanpaKeterangan();
    this.fetchJamKerjaKurang();
    this.fetchKaryawanPerPeriodeAlokasiPekerjaan();
    this.fetchProyekPerPeriodeAlokasiPekerjaan();
    this.fetchPekerjaanPerPeriodeAlokasiPekerjaan();
    this.fetchKaryawanPerProyekPerPeriodeAlokasiPekerjaan();
    this.fetchStatusKaryawan();
    this.fetchHotIssue();
    this.fetchSeringLembur();
    this.fetchSeringSppd();
    this.fetchSeringKlaimKesehatan();
    this.fetchSenioritas();
    this.fetchMasaKerja();
    this.fetchHabisKontrak();
    this.fetchPensiun();
    this.fetchWorkforce();
  },
  methods: {
    moment,
    optionFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    f_dateChange() {
      this.fetchSeringTerlambat();
      this.fetchSeringLupaCheckOut();
      this.fetchSeringPulangAwal();
      this.fetchIjinTerlambat();
      this.fetchIjinSakit();
      this.fetchIjinLain();
      this.fetchIjinPulangAwal();
      this.fetchSeringCuti();
      this.fetchSeringTanpaKeterangan();
      this.fetchJamKerjaKurang();
      this.fetchKaryawanPerPeriodeAlokasiPekerjaan();
      this.fetchProyekPerPeriodeAlokasiPekerjaan();
      this.fetchPekerjaanPerPeriodeAlokasiPekerjaan();
      this.fetchKaryawanPerProyekPerPeriodeAlokasiPekerjaan();
      this.fetchHotIssue();
      this.fetchSeringLembur();
      this.fetchSeringSppd();
      this.fetchSeringKlaimKesehatan();
      this.fetchSenioritas();
      this.fetchMasaKerja();
    },
    f_limitChange() {
      this.fetchSeringTerlambat();
      this.fetchSeringLupaCheckOut();
      this.fetchSeringPulangAwal();
      this.fetchIjinTerlambat();
      this.fetchIjinSakit();
      this.fetchIjinLain();
      this.fetchIjinPulangAwal();
      this.fetchSeringCuti();
      this.fetchSeringTanpaKeterangan();
      this.fetchJamKerjaKurang();
      this.fetchKaryawanPerPeriodeAlokasiPekerjaan();
      this.fetchProyekPerPeriodeAlokasiPekerjaan();
      this.fetchPekerjaanPerPeriodeAlokasiPekerjaan();
      this.fetchKaryawanPerProyekPerPeriodeAlokasiPekerjaan();
      this.fetchHotIssue();
      this.fetchSeringLembur();
      this.fetchSeringSppd();
      this.fetchSeringKlaimKesehatan();
      this.fetchMasaKerja();
      this.fetchHabisKontrak();
      this.fetchPensiun();
    },
    async fetchSeringTerlambat() {
      this.loadingSeringTerlambat.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_terlambat",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listSeringTerlambat = [];
          response.data.data.forEach(data => {
            this.listSeringTerlambat.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingSeringTerlambat.shift();
        })
        .catch(err => {
          this.loadingSeringTerlambat.shift();
          console.log(err.response);
        });
    },
    async fetchSeringLupaCheckOut() {
      this.loadingSeringLupaCheckOut.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_lupa_checkout",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listSeringLupaCheckOut = [];
          response.data.data.forEach(data => {
            this.listSeringLupaCheckOut.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingSeringLupaCheckOut.shift();
        })
        .catch(err => {
          this.loadingSeringLupaCheckOut.shift();
          console.log(err.response);
        });
    },
    async fetchSeringPulangAwal() {
      this.loadingSeringPulangAwal.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_pulang_awal",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listSeringPulangAwal = [];
          response.data.data.forEach(data => {
            this.listSeringPulangAwal.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingSeringPulangAwal.shift();
        })
        .catch(err => {
          this.loadingSeringPulangAwal.shift();
          console.log(err.response);
        });
    },
    async fetchIjinTerlambat() {
      this.loadingIjinTerlambat.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_ijin_terlambat",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listIjinTerlambat = [];
          response.data.data.forEach(data => {
            this.listIjinTerlambat.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingIjinTerlambat.shift();
        })
        .catch(err => {
          this.loadingIjinTerlambat.shift();
          console.log(err.response);
        });
    },
    async fetchIjinSakit() {
      this.loadingIjinSakit.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_ijin_sakit",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listIjinSakit = [];
          response.data.data.forEach(data => {
            this.listIjinSakit.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingIjinSakit.shift();
        })
        .catch(err => {
          this.loadingIjinSakit.shift();
          console.log(err.response);
        });
    },
    async fetchIjinLain() {
      this.loadingIjinLain.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_ijin_lain",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listIjinLain = [];
          response.data.data.forEach(data => {
            this.listIjinLain.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingIjinLain.shift();
        })
        .catch(err => {
          this.loadingIjinLain.shift();
          console.log(err.response);
        });
    },
    async fetchIjinPulangAwal() {
      this.loadingIjinPulangAwal.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_ijin_pulang_awal",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listIjinPulangAwal = [];
          response.data.data.forEach(data => {
            this.listIjinPulangAwal.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingIjinPulangAwal.shift();
        })
        .catch(err => {
          this.loadingIjinPulangAwal.shift();
          console.log(err.response);
        });
    },
    async fetchSeringCuti() {
      this.loadingSeringCuti.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_cuti",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listSeringCuti = [];
          response.data.data.forEach(data => {
            this.listSeringCuti.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingSeringCuti.shift();
        })
        .catch(err => {
          this.loadingSeringCuti.shift();
          console.log(err.response);
        });
    },
    async fetchSeringTanpaKeterangan() {
      this.loadingSeringTanpaKeterangan.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_sering_tanpa_keterangan",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listSeringTanpaKeterangan = [];
          response.data.data.forEach(data => {
            this.listSeringTanpaKeterangan.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.loadingSeringTanpaKeterangan.shift();
        })
        .catch(err => {
          this.loadingSeringTanpaKeterangan.shift();
          console.log(err.response);
        });
    },
    async fetchJamKerjaKurang() {
      this.loadingJamKerjaKurang.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_jam_kerja_kurang",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listJamKerjaKurang = [];
          response.data.data.forEach(data => {
            this.listJamKerjaKurang.push({
              title: data.tlc,
              description: data.nama,
              amount: data.persen_kurang + "%",
              amount2: data.kurang_jam
            });
          });

          this.loadingJamKerjaKurang.shift();
        })
        .catch(err => {
          this.loadingJamKerjaKurang.shift();
          console.log(err.response);
        });
    },
    async fetchKaryawanPerPeriodeAlokasiPekerjaan() {
      this.loadingKaryawanPerPeriode.push(true);
      await axios({
        method: "get",
        url:
          this.$serviceUrl + "dashboard/karyawan_per_periode_alokasi_pekerjaan",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.amountKaryawanPerPeriode = response.data.data
            ? response.data.data.length.toString()
            : "";

          this.loadingKaryawanPerPeriode.shift();
        })
        .catch(err => {
          this.loadingKaryawanPerPeriode.shift();
          console.log(err.response);
        });
    },
    async fetchProyekPerPeriodeAlokasiPekerjaan() {
      this.loadingProyekPerPeriode.push(true);
      await axios({
        method: "get",
        url:
          this.$serviceUrl + "dashboard/proyek_per_periode_alokasi_pekerjaan",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.amountProyekPerPeriode = response.data.data
            ? response.data.data.length.toString()
            : "0";

          this.loadingProyekPerPeriode.shift();
        })
        .catch(err => {
          this.loadingProyekPerPeriode.shift();
          console.log(err.response);
        });
    },
    async fetchPekerjaanPerPeriodeAlokasiPekerjaan() {
      this.loadingPekerjaanPerPeriode.push(true);
      await axios({
        method: "get",
        url:
          this.$serviceUrl +
          "dashboard/pekerjaan_per_periode_alokasi_pekerjaan",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.amountPekerjaanPerPeriode = response.data.data
            ? response.data.data.length.toString()
            : "0";

          this.loadingPekerjaanPerPeriode.shift();
        })
        .catch(err => {
          this.loadingPekerjaanPerPeriode.shift();
          console.log(err.response);
        });
    },
    async fetchKaryawanPerProyekPerPeriodeAlokasiPekerjaan() {
      this.loadingKaryawanPerProyekPerPeriode.push(true);
      this.alokasiChartData = {
        labels: [],
        datasets: []
      };
      await axios({
        method: "get",
        url:
          this.$serviceUrl +
          "dashboard/karyawan_per_proyek_per_periode_alokasi_pekerjaan",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listKaryawanPerProyekPerPeriode = response.data.data;
          const proyek = response.data.data.map(obj => obj.c_proyek);
          const jumlah = response.data.data.map(obj => obj.amount);
          this.alokasiChartData = {
            labels: proyek,
            datasets: [
              {
                label: "Jumlah Perkerjaan",
                backgroundColor: "#30a679",
                data: jumlah
              }
            ]
          };
          this.loadingKaryawanPerProyekPerPeriode.shift();
        })
        .catch(err => {
          this.loadingKaryawanPerProyekPerPeriode.shift();
          console.log(err.response);
        });
    },
    async fetchStatusKaryawan() {
      this.loadingStatusKaryawan.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/status_karyawan",
        params: {
          status: this.f_status,
          posisi: this.f_posisi,
          divisi: this.f_divisi
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listStatusKaryawan = response.data.data;
          this.listDivisi = response.data.divisi_opt;
          this.listPosisi = response.data.posisi_opt;

          this.loadingStatusKaryawan.shift();
        })
        .catch(err => {
          this.loadingStatusKaryawan.shift();
          console.log(err.response);
        });
    },
    async fetchSeringLembur() {
      this.loadingSeringLembur.push(true);
      this.lemburChartData = {
        labels: [],
        datasets: []
      };
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/panel_lembur",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listSeringLembur = response.data.karyawan_lembur;
          this.amountLemburTerbayar = this.formatRupiah(
            response.data.lembur_terbayar
          );
          const proyek = response.data.proyek_lembur.map(obj => obj.proyek);
          const count = response.data.proyek_lembur.map(obj => obj.count);
          this.lemburChartData = {
            labels: proyek,
            datasets: [
              {
                label: "Jumlah SPL",
                backgroundColor: "#30a679",
                data: count
              }
            ]
          };
          const chartHeight = proyek.length * 40 + 150;
          this.lemburChartHeight = chartHeight > 400 ? chartHeight : 400;
          this.loadingSeringLembur.shift();
        })
        .catch(err => {
          this.loadingSeringLembur.shift();
          console.log(err.response);
        });
    },
    async fetchSeringSppd() {
      this.loadingSeringSppd.push(true);
      this.spdChartData = {
        labels: [],
        datasets: []
      };
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/panel_sppd",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listSeringSppd = [];
          // response.data.karyawan_sppd.forEach((data) => {
          //   this.listSeringSppd.push({
          //     title: data.tlc,
          //     description: data.nama,
          //     amount: data.count,
          //   });
          // });

          this.listSeringSppd = response.data.karyawan_sppd;

          this.amountSppdTerekap = this.formatRupiah(
            response.data.sppd_terekap
          );
          const proyek = response.data.proyek_sppd.map(obj => obj.proyek);
          const amount = response.data.proyek_sppd.map(obj => obj.amount);
          this.spdChartData = {
            labels: proyek,
            datasets: [
              {
                label: "Jumlah SPD",
                backgroundColor: "#30a679",
                data: amount
              }
            ]
          };
          const chartHeight = proyek.length * 40 + 150;
          this.spdChartHeight = chartHeight > 400 ? chartHeight : 400;
          this.loadingSeringSppd.shift();
        })
        .catch(err => {
          this.loadingSeringSppd.shift();
          console.log(err.response);
        });
    },
    async fetchSeringKlaimKesehatan() {
      this.loadingSeringKlaimKesehatan.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/panel_klaim_kesehatan",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listSeringKlaimKesehatan = [];
          response.data.karyawan_klaim_kesehatan.forEach(data => {
            this.listSeringKlaimKesehatan.push({
              title: data.tlc,
              description: data.nama,
              amount: data.count
            });
          });

          this.amountKlaimApproved = this.formatRupiah(
            response.data.klaim_approved
          );

          this.listRealisasiKlaimKesehatanTerbanyak =
            response.data.realisasi_klaim_kesehatan;

          this.loadingSeringKlaimKesehatan.shift();
        })
        .catch(err => {
          this.loadingSeringKlaimKesehatan.shift();
          console.log(err.response);
        });
    },
    async fetchHotIssue() {
      this.loadingHotIssue.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/hot_issue",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listHotIssue = [];
          this.totalHotIssue = response.data.total_data;
          this.listHotIssue = response.data.data;
          this.loadingHotIssue.shift();
        })
        .catch(err => {
          this.loadingHotIssue.shift();
          console.log(err.response);
        });
    },
    async fetchSenioritas() {
      this.loadingSenioritas.push(true);
      this.senioritasChartData = {
        labels: [],
        datasets: []
      };
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/panel_senioritas",
        params: {
          periode: moment(this.f_date).format("YYYYMM")
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          if (response.data.data) {
            const hasil = response.data.data[0];

            this.senioritasChartData = {
              labels: [
                "Junior (0-2 tahun)",
                "Mid (2-5 tahun)",
                "Senior (>5 tahun)"
              ],
              datasets: [
                {
                  label: "Jumlah Karyawan",
                  backgroundColor: ["#ADFF2F", "#2E8B57", "#1E90FF"],
                  data: [hasil.junior, hasil.mid, hasil.senior]
                }
              ]
            };
          }
          this.loadingSenioritas.shift();
        })
        .catch(err => {
          this.loadingSenioritas.shift();
          console.log(err.response);
        });
    },
    async fetchMasaKerja() {
      this.loadingMasaKerja.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/masa_kerja",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listMasaKerja = [];
          response.data.data.forEach(data => {
            this.listMasaKerja.push({
              title: data.tlc,
              description: data.nama,
              amount: data.masa_kerja
            });
          });

          this.loadingMasaKerja.shift();
        })
        .catch(err => {
          this.loadingMasaKerja.shift();
          console.log(err.response);
        });
    },
    async fetchHabisKontrak() {
      this.loadingHabisKontrak.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_habis_kontrak",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listHabisKontrak = [];
          this.listHabisKontrak = response.data.data;
          this.loadingHabisKontrak.shift();
        })
        .catch(err => {
          this.loadingHabisKontrak.shift();
          console.log(err.response);
        });
    },
    async fetchPensiun() {
      this.loadingPensiun.push(true);
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/karyawan_pensiun",
        params: {
          periode: moment(this.f_date).format("YYYYMM"),
          limit: this.f_limit
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.listPensiun = [];
          this.listPensiun = response.data.data;
          this.loadingPensiun.shift();
        })
        .catch(err => {
          this.loadingPensiun.shift();
          console.log(err.response);
        });
    },
    f_statusChange() {
      this.fetchStatusKaryawan();
    },
    f_divisiChange() {
      this.fetchStatusKaryawan();
    },
    f_posisiChange() {
      this.fetchStatusKaryawan();
    },
    handleReset() {
      this.f_status = "";
      this.f_posisi = "";
      this.f_divisi = "";

      this.fetchStatusKaryawan();
    },
    getColorStatus(status) {
      let color = "";

      if (status == "Habis Kontrak") {
        color = "red";
      } else if (status == "Kontrak") {
        color = "blue";
      } else if (status == "Pensiun") {
        color = "gray";
      } else if (status == "Resign") {
        color = "orange";
      } else if (status == "Tetap") {
        color = "green";
      }

      return color;
    },
    getIssueDescStatus(status) {
      let desc = "";
      if (status == 1) {
        desc = "Done";
      } else {
        desc = "In progress";
      }
      return desc;
    },
    getIssueColorStatus(status) {
      let color = "";
      if (status == 1) {
        color = "green";
      } else {
        color = "orange";
      }
      return color;
    },
    handlePrint(event) {
      event.stopPropagation();

      //proses cetak tiap panel
      this.loadingCetak = true;
      let parameters = {
        periode: moment(this.f_date).format("YYYYMM"),
        limit: this.f_limit,
        panel: this.activeKey,
        posisi: this.f_posisi,
        divisi: this.f_divisi,
        status: this.f_status
      };

      axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/cetak",
        responseType: "blob",
        params: parameters,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.loadingCetak = false;
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          // if (parameters.rekap_sts == "0" && this.isHRD) {
          //   this.pageLoading = false;
          // } else {
          //   this.printLoading = false;
          // }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan System, error code 404!"
            });
          }
          this.loadingCetak = false;
          // if (parameters.rekap_sts == "0" && this.isHRD) {
          //   this.pageLoading = false;
          // } else {
          //   this.printLoading = false;
          // }
          //this.$router.go();
        });
    },
    handlePrintAll() {
      //proses cetak all panel
      this.loadingCetakAll = true;
      let parameters = {
        periode: moment(this.f_date).format("YYYYMM"),
        limit: this.f_limit,
        panel: "All",
        posisi: this.f_posisi,
        divisi: this.f_divisi,
        status: this.f_status
      };

      axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/cetak",
        responseType: "blob",
        params: parameters,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.loadingCetakAll = false;
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          // if (parameters.rekap_sts == "0" && this.isHRD) {
          //   this.pageLoading = false;
          // } else {
          //   this.printLoading = false;
          // }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan System, error code 404!"
            });
          }
          this.loadingCetakAll = false;
          // if (parameters.rekap_sts == "0" && this.isHRD) {
          //   this.pageLoading = false;
          // } else {
          //   this.printLoading = false;
          // }
          //this.$router.go();
        });
    },
    openFile(filename) {
      let url =
        process.env.VUE_APP_SERVICEURL + "assets/upload/issue/" + filename;
      window.open(url, "_blank");
    },
    getRandomColor(length) {
      var letters = "0123456789ABCDEF".split("");
      var color = "#";
      var arrColor = [];
      for (var i = 0; i < length; i++) {
        for (var j = 0; j < 6; j++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        arrColor.push(color);
        color = "#";
      }

      return arrColor;
    },
    async fetchWorkforce() {
      this.loadingWorkforce.push(true);
      this.totalKaryawanChartData = {
        labels: [],
        datasets: []
      };
      this.usiaKaryawanChartData = {
        labels: [],
        datasets: []
      };
      this.siteKaryawanChartData = {
        labels: [],
        datasets: []
      };
      this.genderKaryawanChartData = {
        labels: [],
        datasets: []
      };
      this.pendidikanKaryawanChartData = {
        labels: [],
        datasets: []
      };
      this.agamaKaryawanChartData = {
        labels: [],
        datasets: []
      };
      await axios({
        method: "get",
        url: this.$serviceUrl + "dashboard/panel_workforce",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          const status = response.data.total_karyawan.map(obj => obj.status);
          const amount1 = response.data.total_karyawan.map(obj => obj.amount);
          this.totalKaryawanChartData = {
            labels: status,
            datasets: [
              {
                backgroundColor: this.getRandomColor(status.length),
                data: amount1
              }
            ]
          };

          const age_group = response.data.usia_karyawan.map(
            obj => obj.age_group
          );
          const amount2 = response.data.usia_karyawan.map(obj => obj.amount);
          this.usiaKaryawanChartData = {
            labels: age_group,
            datasets: [
              {
                backgroundColor: this.getRandomColor(age_group.length),
                data: amount2
              }
            ]
          };

          const site = response.data.site_karyawan.map(obj => obj.site);
          const amount3 = response.data.site_karyawan.map(obj => obj.amount);
          this.siteKaryawanChartData = {
            labels: site,
            datasets: [
              {
                backgroundColor: this.getRandomColor(site.length),
                data: amount3
              }
            ]
          };

          const pendidikan = response.data.pendidikan_karyawan.map(
            obj => obj.pendidikan
          );
          const amount4 = response.data.pendidikan_karyawan.map(
            obj => obj.amount
          );
          this.pendidikanKaryawanChartData = {
            labels: pendidikan,
            datasets: [
              {
                backgroundColor: this.getRandomColor(pendidikan.length),
                data: amount4
              }
            ]
          };

          const gender = response.data.gender_karyawan.map(obj => obj.gender);
          const amount5 = response.data.gender_karyawan.map(obj => obj.amount);
          this.genderKaryawanChartData = {
            labels: gender,
            datasets: [
              {
                backgroundColor: this.getRandomColor(gender.length),
                data: amount5
              }
            ]
          };

          const agama = response.data.agama_karyawan.map(obj => obj.agama);
          const amount6 = response.data.agama_karyawan.map(obj => obj.amount);
          this.agamaKaryawanChartData = {
            labels: agama,
            datasets: [
              {
                backgroundColor: this.getRandomColor(agama.length),
                data: amount6
              }
            ]
          };

          this.listCutiIjinDinasKaryawanToday =
            response.data.ijin_cuti_pd_karyawan;

          this.loadingWorkforce.shift();
        })
        .catch(err => {
          this.loadingWorkforce.shift();
          console.log(err.response);
        });
    }
  }
};
</script>

<style>
.row-danger {
  background-color: #dd4646;
}

.row-warning {
  background-color: #f8f54f;
}
</style>
